import { metaToConsts } from "@/shared/lib/meta-to-consts";
import { metaToMap } from "@/shared/lib/meta-to-map";
import type { ValueMeta } from "@/shared/model";

/**
 * 진입 유형 Meta
 *
 * 사용자가 서비스에 접근하는 방식을 구분
 * - member: 로그인한 회원
 * - guest: 비로그인 비회원
 */
export const ENTRY_TYPE_META = [
  { id: "ET01", name: "MEMBER", label: "회원", value: "member" },
  { id: "ET02", name: "GUEST", label: "비회원", value: "guest" },
] as const satisfies readonly ValueMeta<string>[];

export const ENTRY_TYPE_VALUE = metaToConsts(ENTRY_TYPE_META);
export const ENTRY_TYPE_MAP = metaToMap(ENTRY_TYPE_META);
